import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

export const StyledFeaturesDescriptionList = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 12px;

  .features-description-item {
    display: flex;
    align-items: flex-start;
    gap: 8px;
  }

  .check-icon {
    display: block;
    color: ${COLOR.tooltipColor};
    font-size: 20px;
    flex-shrink: 0;
  }

  .check-icon.coming-soon-text-advanced {
    color: ${COLOR.indigoColor};
  }

  .feature-text {
    color: ${COLOR.label2[100]};
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.4px;
    word-wrap: break-word;

    strong {
      font-weight: 700;
    }

    p {
      margin: 0;
    }
  }

  .feature-text.advanced {
    color: ${COLOR.indigoColor};
    font-weight: 700;
  }

  .coming-soon-title {
    color: ${COLOR.descriptionUpload};
    font-size: 14px;
    margin-left: 5px;
    font-weight: 400;
  }
`;
